export const CREDIT_MEMO = 1;
